const CONFIG = {
  baseURL : '/api/v1',
  tokenKey: 'judge-token',
  currentIndexKey: 'questionnaire-current-index',
  percentageIndexKey:'questionnaire-percentage-index',
  expirationKey:'questionnaire-expiration'
}
export default CONFIG
